export default __webpack_public_path__ + "static/media/deleteIcon_B.aff14af7.svg";